import React from "react";
import "./FastCasinoGameDevelopmentSuperiorStyle.scss";
import { fastCasinoGameDevelopmentSuperiorTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const FastCasinoGameDevelopmentSuperiorSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/`);
  };

  return (
    <section className="fast-casino-game-development-superior-section">
      <div className="fast-casino-game-development-superior-wrap">
        <SectionHeading>{fastCasinoGameDevelopmentSuperiorTextContent.headingText}</SectionHeading>

        <div className="fast-casino-game-development-superior-box">
          <div className="cards-grid">
            {fastCasinoGameDevelopmentSuperiorTextContent.content.map((section, index) => (
              <div className="card" key={index}>
                <div className="card-body">
                  <h1 className="number-text">{section.numberText}</h1>
                  <h5 className="title-text">{section.titleText}</h5>
                </div>
              </div>
            ))}
          </div>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={fastCasinoGameDevelopmentSuperiorTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FastCasinoGameDevelopmentSuperiorSection;
